import { render, staticRenderFns } from "./AvatarMenu.vue?vue&type=template&id=d9cc0380&scoped=true"
import script from "./AvatarMenu.vue?vue&type=script&lang=js"
export * from "./AvatarMenu.vue?vue&type=script&lang=js"
import style0 from "./AvatarMenu.vue?vue&type=style&index=0&id=d9cc0380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cc0380",
  null
  
)

export default component.exports